import { Injectable } from '@angular/core';

@Injectable()
export class DateUtilsService {
    public getDateOrDash = (value: string): any => {
        const timeStamp: number = Date.parse(value);

        if (isNaN(timeStamp)) {
            return value;
        }

        return new Date(value);
    }
}
